export default "/static/webpack/media/no-departments.78d9ec35.svg";